<template>
  <div>
    <q-select
      dense
      outlined
      :model-value="props.modelValue"
      @update:model-value="(value) => $emit('update:modelValue', value)"
      :options="listaSolicitantes"
      option-label="name"
      option-value="id"
      :label="props.label"
      label-color="grey-6"
      behavior="menu"
      :multiple="multiple"
      map-options
      use-input
      @filter="filtrar"
      :display-value="
        modelValue?.name?.length > props.lengthHidden
          ? `${modelValue?.name?.substring(0, props.lengthHidden)}....`
          : modelValue?.name
      "
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section>Nenhum resultado</q-item-section>
        </q-item>
      </template>
      <q-tooltip v-if="modelValue"> {{ props?.modelValue?.name }} </q-tooltip>
    </q-select>
  </div>
</template>

<script setup>
// @TODO Alterar para usar o "defineModel" das ultimas versões do vue
import { /*defineModel*/ ref, defineProps, computed } from "vue";
import { useStore } from "vuex";
import { usuarioTemPermissao } from "../../../../helpers/permissaoHelper";

const store = useStore();
const props = defineProps({
  modelValue: {},
  multiple: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: "Selecione o Solicitante",
  },
  lengthHidden: {
    type: Number,
    default: 9,
  },
  vendorId: {
    default: null,
  },
});

const temPermissaoTodosUsuarios = computed(() =>
  usuarioTemPermissao(store, "visualizar_todos_usuários")
);

const listaSolicitantes = ref([]);

const listarSolicitantes = async (val) => {
  listaSolicitantes.value = [];
  try {
    const vendorId = temPermissaoTodosUsuarios.value
      ? undefined
      : props.vendorId || store.state.org.unidadeData?.id || undefined;

    const response = await store.dispatch("compras/getSolicitantes", {
      vendor_id: vendorId,
      search: val,
    });

    listaSolicitantes.value = response.data.results.data;
  } catch (error) {
    console.log(error);
  }
};

const filtrar = async (val, update) => {
  await listarSolicitantes(val);
  update();
};
</script>
